import DEFAULT_PROP from '@/assets/json/field_types.json'
import { mapGetters } from 'vuex'
export default {
  ...mapGetters(['getuserDetails']),
  data () {
    return {
      folderTemplateDialog: false,
      folderTemplateDialogLoader: false,
      folderTemplates: [],
      folderTemplateSubmitBtnLoading: false,
      documentFormloading: false,
      isShowAttachment: false,
      selectedFolderTemplate: null,
      templateList: [],
      selectedDocument: {},
      docuSignDialog: false
    }
  },
  computed: {
    propertiesFormReference () {
      return {
        title: this.isShowAttachment ? this.$t('message.hse.upload') : this.$t('message.hse.updateMetaData'),
        properties: this.formProps,
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.isShowAttachment ? this.$t('message.hse.upload') : this.$t('message.common.update'),
          click: this.isShowAttachment ? this.uploadDocumentHandler : this.updateDocumentMeta,
          loading: this.documentFormloading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDocumentDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    createFolderReferences () {
      return {
        title: this.isCreateFolder ? this.$t('message.hse.createNew') : this.$t('message.hse.editName'),
        properties: [{
          model: 'folder_name',
          type: this.formType.TEXT,
          rules: [],
          label: this.$t('message.hse.folderName'),
          class: 'sm12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          loading: this.folderLoading,
          label: this.isCreateFolder ? this.$t('message.certificate.create') : this.$t('message.common.update'),
          click: this.saveOrUpdateFolder,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeFolderDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    templateFormReference () {
      return {
        title: this.$t('message.certificate.create'),
        properties: this.formProps,
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$t('message.hse.upload'),
          click: this.uploadTemplateHandler,
          loading: this.documentFormloading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDocumentDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    pdfSignActions () {
      let actions = [{
        tooltip: this.$t('message.documents.documentSignature'),
        icon: 'mdi-file-sign',
        color: 'cyan',
        value: 'convertToPdf',
        click: (document) => this.openDocuSignDialog(document)
      }]
      return actions
    },
    documentActions () {
      let actions = [{
        tooltip: this.$t('message.document.versioningDocuments'),
        icon: 'mdi-checkerboard-plus',
        color: 'primary',
        requiresPermission: true,
        click: (document) => this.versioningDocuments(document)
      }, {
        tooltip: this.$t('message.hse.openNewTab'),
        icon: 'mdi-open-in-new',
        color: 'primary',
        click: (document) => this.navigateToOD(document)
      }, {
        tooltip: this.$t('message.hse.editMeta'),
        icon: 'mdi-border-color',
        requiresPermission: true,
        color: 'success',
        click: (document) => this.editMetaInDocument(document)
      }, {
        tooltip: this.$t('message.order.download'),
        icon: 'mdi-cloud-download',
        color: 'accent',
        click: (document) => this.downloadHandler(document.id)
      }, {
        tooltip: this.$t('message.document.versionHistory'),
        icon: 'mdi-history',
        color: 'purple',
        click: (document) => this.getVersionInfo(document.id)
      }, {
        tooltip: this.$t('message.common.delete'),
        icon: 'mdi-delete',
        requiresPermission: true,
        color: 'error',
        click: (document) => this.deleteHandler(document.id)
      }]
      if (this.noPermissionToChange) {
        actions = actions.filter(x => !x.requiresPermission)
      }
      return actions
    },
    folderActions () {
      let actions = [{
        tooltip: this.$t('message.hse.openNewTab'),
        icon: 'mdi-open-in-new',
        color: 'primary',
        click: (document) => this.navigateHandler(document.isdocument ? document.path : document.weburl)
      }, {
        tooltip: this.$t('message.hse.editName'),
        icon: 'mdi-border-color',
        requiresPermission: true,
        color: 'success',
        click: (document, obj, index) => this.renameFolderFormShow(document, obj, index)
      }, {
        tooltip: this.$t('message.common.delete'),
        icon: 'mdi-delete',
        requiresPermission: true,
        color: 'error',
        click: (document) => this.deleteHandler(document.id)
      }]
      if (this.noPermissionToChange) {
        actions = actions.filter(x => !x.requiresPermission)
      }
      return actions
    }
  },
  methods: {
    prepareFieldsForProperties () {
      const dynamicInputs = []
      this.dateFieldsForConversion = []
      for (let i = 0; i < this.dynamicFormFields.length; i++) {
        const field = this.dynamicFormFields[i]
        if (field.type === DEFAULT_PROP.DATETIME) this.dateFieldsForConversion.push(field.name)
        if (!field.readonly) {
          switch (field.type) {
            case DEFAULT_PROP.URL:
            case DEFAULT_PROP.TEXT:
            case DEFAULT_PROP.FILE:
            case DEFAULT_PROP.CURRENCY:
              dynamicInputs.push({ model: field.name, ref: 'textFields', type_ref: field.type, type: this.formType.TEXT, label: field.title, class: 'xs12' })
              break
            case DEFAULT_PROP.NUMBER:
            case DEFAULT_PROP.INTERGER:
              dynamicInputs.push({ model: field.name, type_ref: field.type, type: this.formType.NUMBER, label: field.title, class: 'xs12' })
              break
            case DEFAULT_PROP.NOTE:
              dynamicInputs.push({ model: field.name, type_ref: field.type, type: this.formType.TEXTAREA, label: field.title, class: 'xs12' })
              break
            case DEFAULT_PROP.BOOLEAN:
              dynamicInputs.push({ model: field.name, type_ref: field.type, type: this.formType.CHECKBOX, label: field.title, class: 'xs12' })
              break
            case DEFAULT_PROP.CHOICE:
              dynamicInputs.push({ model: field.name, type_ref: field.type, type: this.formType.AUTO_COMPLETE, items: field.choices, label: field.title, class: 'xs12' })
              break
            case DEFAULT_PROP.MULTICHOICE:
              dynamicInputs.push({ model: field.name, type_ref: field.type, type: this.formType.AUTO_COMPLETE, items: field.choices, multiple: true, label: field.title, class: 'xs12' })
              break
            case DEFAULT_PROP.USER:
              dynamicInputs.push({ model: field.name, readonly: true, type_ref: field.type, type: this.formType.AUTO_COMPLETE, items: field.users, select_value: 'id', select_text: 'name', label: field.title, class: 'xs12' })
              break
            case DEFAULT_PROP.DATETIME:
              dynamicInputs.push({ model: field.name, type_ref: field.type, type: this.formType.DATEPICKER, menu: `${field.name}_menu`, picker: `${field.name}_picker`, label: field.title, class: 'xs12', color: 'primary lighten-1' })
              this.$watch(`propertyModel.properties.${field.name}_picker`, (val) => {
                if (val) {
                  this.propertyModel.properties[field.name] = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
                }
              })
              break
            default:
              break
          }
        }
      }
      this.formProps = dynamicInputs
    },
    documentDialog (files) {
      this.isShowAttachment = true
      this.uploadDocumentDialog = true
      const attachmentRefIndex = this.formProps.findIndex(x => x.model === 'files')
      // const templateRefIndex = this.formProps.findIndex(x => x.model === 'template')
      const getModels = this.formProps.filter(x => x.type_ref === DEFAULT_PROP.USER)
      let userModel = {}
      if (getModels && this.getuserDetails) {
        getModels.map(x => {
          const getUser = x.items.find(x => x.email === this.getuserDetails.username)
          userModel = Object.assign({ ...userModel }, { [x.model]: getUser ? getUser.id : 0 })
        })
      }
      // if (templateRefIndex >= 0) this.formProps.splice(templateRefIndex, 1)
      this.propertyModel = { properties: { ...userModel } }
      if (attachmentRefIndex < 0) {
        this.formProps.unshift({
          model: 'files',
          type: this.formType.FILES,
          is_show: this.isShowAttachment,
          multiple: true,
          is_file: true,
          value: this.droppedFiles,
          change: this.getFileName,
          rules: this.$_multiSelectValidation,
          label: this.$t('message.hse.files'),
          class: 'lg12'
        })
        if (this.module === this.SP_PRODUCT) {
          this.formProps.splice(1, 0, {
            model: 'batchNo',
            type: this.formType.SELECT,
            items: this.listOfBatchNumbers,
            select_text: 'batchnumber',
            select_value: 'batchnumber',
            is_show: this.isShowAttachment,
            label: this.$t('message.order.batchNo'),
            class: 'lg12'
          })
        }
      }
      const templateRef = this.formProps.findIndex(x => x.model === 'template')
      if (templateRef > 0) {
        this.formProps.splice(templateRef, 1)
      }
      setTimeout(() => {
        let result = []
        if (files) {
          for (let i = 0; i < files.length; i++) {
            result.push(files[i])
          }
          this.$set(this.propertyModel.properties, 'files', [])
          this.$set(this.propertyModel.properties, 'files', result)
        }
      }, 500)
    },
    getFileName () {
      const file = this.propertyModel.properties.files ? this.propertyModel.properties.files[0] : null
      const fileName = file && file.name ? file.name : null
      if (this.$refs.documentReference.$refs.textFields && this.$refs.documentReference.$refs.textFields[0]) {
        this.$set(this.propertyModel, 'properties', { ...this.propertyModel.properties, FileLeafRef: fileName })
        this.$refs.documentReference.$refs.textFields[0].focus()
      }
    },
    folderDialog () {
      this.createFolderDialog = true
      this.isCreateFolder = true
    },
    showFolderTemplateDialog () {
      this.folderTemplateDialog = true
      this.folderTemplateDialogLoader = true
      this.$_executeApi('get', 'foldertemplates/get_templates').then(({ data }) => {
        this.folderTemplates = data
      }).finally(() => { this.folderTemplateDialogLoader = false })
    },
    templateHandler () {
      this.isShowAttachment = true
      this.templateDialog = true
      this.propertyModel = { properties: {} }
      const attachmentRefIndex = this.formProps.findIndex(x => x.model === 'files')
      if (attachmentRefIndex >= 0) this.formProps.splice(attachmentRefIndex, 1)
      const templateRef = this.formProps.findIndex(x => x.model === 'template')
      if (templateRef < 0) {
        this.formProps.unshift({
          model: 'template',
          type: this.formType.SELECT,
          rules: this.$_requiredValidation,
          items: this.templateList,
          select_text: 'name',
          change: this.getTemplateName,
          select_value: 'id',
          label: this.$t('message.props.template'),
          class: 'lg12'
        })
      }
      const getModels = this.formProps.filter(x => x.type_ref === DEFAULT_PROP.USER)
      let userModel = {}
      if (getModels && this.getuserDetails) {
        getModels.map(x => {
          const getUser = x.items.find(x => x.email === this.getuserDetails.username)
          userModel = Object.assign({ ...userModel }, { [x.model]: getUser ? getUser.id : 0 })
        })
      }
      this.propertyModel = { properties: { ...userModel } }
    },
    async createFolderTemplate () {
      const getAllLength = this.parentBreadCrumbItems.length
      const getSharepointId = this.parentBreadCrumbItems[getAllLength - 1] ? this.parentBreadCrumbItems[getAllLength - 1].id : this.sharepoint_id
      this.folderTemplateSubmitBtnLoading = true
      var model = { templateid: this.selectedFolderTemplate, folderid: getSharepointId }
      this.$_executeApi('post', 'sharepoint/create_from_template', model).finally(() => {
        this.folderTemplateSubmitBtnLoading = false
        this.folderTemplateDialog = false
        this.selectedFolderTemplate = null
        this.folderTemplates = []
        const getItem = { id: getSharepointId }
        this.getSubFoldersItems(getItem)
      })
    },
    closeFolderTemplateDialog () {
      this.folderTemplateDialog = false
      this.folderTemplates = []
    },
    getModuleTemplates () {
      this.$_executeApi('get', `documenttemplates/get_by_module/${this.module}`)
        .then(response => {
          this.templateList = []
          this.templateList = response.data
        })
    },
    getTemplateName () {
      if (this.$refs.documentReference.$refs.textFields && this.$refs.documentReference.$refs.textFields[0]) {
        this.$refs.documentReference.$refs.textFields[0].focus()
      }
      // const template = this.propertyModel.properties.template
      // let getTemplate = {}
      // if (template) {
      //   getTemplate = this.templateList.find(x => x.id === template)
      // }
      // const templateName = getTemplate ? getTemplate.name : null
      // const getNameFields = this.formProps.filter(x => x.type_ref === 2 || x.type_ref === 18) // 2 - TITLE, 18 - NAME
      // const getFileNames = {}
      // getNameFields.map(x => {
      //   getFileNames[x.model] = templateName || ''
      // })
      // this.propertyModel.properties = Object.assign({ ...this.propertyModel.properties }, { ...getFileNames })
    },
    editMetaInDocument (item) {
      this.isShowAttachment = false
      this.uploadDocumentDialog = true
      this.propertyModel = this.$formatter.cloneVariable(item)
      const properties = this.propertyModel.properties
      const formModel = {}
      for (let i = 0; i < properties.length; i++) {
        this.dateFieldsForConversion.forEach(element => {
          if (element === properties[i].name && properties[i].value) {
            properties[i].value = this.$formatter.formatDate(properties[i].value, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
          }
        })
        if (properties[i].value && properties[i].value.lookupid) formModel[properties[i].name] = properties[i].value.lookupid
        else formModel[properties[i].name] = properties[i].value
      }
      this.propertyModel.properties = formModel
      const attachmentRefIndex = this.formProps.findIndex(x => x.model === 'files')
      if (attachmentRefIndex >= 0) this.formProps.splice(attachmentRefIndex, 1)
      const headerRefIndex = this.formProps.findIndex(x => x.model === 'header_footer_id')
      if (headerRefIndex >= 0) this.formProps.splice(headerRefIndex, 1)
      const templateRefIndex = this.formProps.findIndex(x => x.model === 'template')
      if (templateRefIndex >= 0) this.formProps.splice(templateRefIndex, 1)
    },
    closeDocumentDialogHandler () {
      this.uploadDocumentDialog = false
      this.templateDialog = false
      this.$refs.documentReference.$refs.validateForm.reset()
      this.propertyModel.properties.files = []
    },
    closeFolderDialogHandler () {
      this.isCreateFolder = false
      this.createFolderDialog = false
      this.$refs.folderReference.$refs.validateForm.reset()
    },
    navigateToOD (document) {
      this.editMetaInDocument(document)
      window.open(document.weburl, '_blank')
    },
    versioningDocuments (document) {
      this.documentDialog()
      this.propertyModel.document_id = document.id
      this.propertyModel.isVersion = true
    },
    navigateHandler (weburl) {
      window.open(weburl, '_blank')
    },
    downloadHandler (id) {
      this.loading = true
      this.$_executeApi('get', `${this.MODULE_URL}/download/${id}`)
        .then((response) => {
          this.loading = false
          window.open(`${process.env.VUE_APP_URL}file/download?fileName=${response.data}`, '_blank')
        })
    },
    generateModelFromFields (model, props) {
      return new Promise((resolve, reject) => {
        const fields = this.$formatter.cloneVariable(props.properties)
        const properties = []
        for (let i = 0; i < fields.length; i++) {
          if (fields[i].type_ref) {
            if (fields[i].type_ref === DEFAULT_PROP.USER) {
              const getUsers = fields[i].items
              const getSelectedUser = getUsers.find(x => x.id === model[fields[i].model])
              properties.push({ name: fields[i].model, type: fields[i].type_ref, label: getSelectedUser ? getSelectedUser.name : '', value: model[fields[i].model] })
            } else {
              properties.push({ name: fields[i].model, type: fields[i].type_ref, label: '', value: model[fields[i].model] })
            }
          }
        }
        resolve(JSON.stringify(properties))
      })
    },
    getVersionInfo (id) {
      this.loading = true
      this.$_executeApi('get', `${this.MODULE_URL}/get_document_versions/${id}`).then(response => {
        this.versionHistory = []
        this.versionHistory = response.data
        this.versionHistoryDialog = true
      }).finally(() => {
        this.loading = false
      })
    },
    deleteHandler (id) {
      const payload = { url: `${this.MODULE_URL}/delete/${id}`, module: this.MODULE_URL, isSingle: true }
      if (this.orderOrOffer) payload.module += this.orderOrOffer
      this.$store.commit('showDeleteDialog', payload)
    },
    navigateToItem (item) {
      this.getSubFoldersItems(item)
    },
    getSubFoldersItems (item) {
      if (item.id) {
        this.documentLoading = true
        this.$_executeApi('get', `sharepoint/get_subfolder_items/${item.id}`)
          .then((response) => {
            const list = response.data
            list.forEach(element => {
              if (!element.is_document) element.mimetype = 'folder'
            })
            this.currentFolderId = this.sharepoint_id
            this.listOfParentDocuments = list
            const breadcrumbItem = { id: item.id, text: item.name, path: item.path, isRoot: item.isRoot }
            const getIndex = this.parentBreadCrumbItems.findIndex(x => x.id === item.id)
            if (getIndex >= 0) {
              const getAll = getIndex + 1
              const getTotalCount = this.parentBreadCrumbItems.length
              this.parentBreadCrumbItems.splice(getAll, getTotalCount - getAll)
            } else {
              this.parentBreadCrumbItems.push(breadcrumbItem)
            }
          })
          .finally(() => {
            this.documentLoading = false
          })
      } else {
        switch (this.module) {
          case this.SP_PRODUCT: this.$root.$emit('get_product_details')
            break
          case this.SP_DEVIATION: this.$root.$emit('get_deviation_details')
            break
          case this.SP_SUPPLIER_ORDER: this.$root.$emit('get_supplierorder_details')
            break
          case this.SP_ORDER: this.$root.$emit('get_orderfromoffer_details')
            break
        }
      }
    },
    renameFolderFormShow (item, obj, index) {
      this.isCreateFolder = false
      this.folderObj = {}
      this.folderObj.id = item.id
      this.folderObj.folder_name = item.name
      this.folderObj.childRef = { item, obj, index }
      this.createFolderDialog = true
    },
    openDocuSignDialog (documentObj) {
      this.docuSignDialog = true
      this.selectedDocument = documentObj
      if (!this.getUsers.length) this.$store.dispatch('getUsers')
    }
  }
}
